import React from 'react';

export default props => {
  const address = [];
  const secondLine = [];
  if (props.twoLines !== undefined) {
    const address = [];
    if (props.address_line_1 !== null && props.address_line_1.length > 0) {
      address.push(props.address_line_1);
      address.push(<br key={'address-line-1'} />);
    }
    if (props.address_line_2 !== null && props.address_line_2.length > 0) {
      address.push(props.address_line_2);
      address.push(<br key={'address-line-2'} />);
    }

    if (props.city !== null && props.city.length > 0) {
      secondLine.push(props.city);
    }
    if (props.state !== null && props.state.length > 0) {
      secondLine.push(props.state);
    }
    if (props.zip_code !== null && props.zip_code.length > 0) {
      secondLine.push(props.zip_code);
    }
    return (
      <React.Fragment>
        {address}
        {secondLine.join(', ')}
      </React.Fragment>
    );
  } else {
    if (props.address_line_1 !== null && props.address_line_1.length > 0) {
      address.push(props.address_line_1);
    }
    if (props.address_line_2 !== null && props.address_line_2.length > 0) {
      address.push(props.address_line_2);
    }
    if (props.city !== null && props.city.length > 0) {
      address.push(props.city);
    }
    if (props.state !== null && props.state.length > 0) {
      if (props.zip_code !== null && props.zip_code.length > 0) {
        address.push(props.state);
        address.push(props.zip_code);
      } else {
        address.push(props.state);
      }
    }

    return <React.Fragment>{address.join(', ')}</React.Fragment>;
  }
};
